<template>
  <div >
    <vs-dropdown
      vs-custom-content
      vs-trigger-click
      class="cursor-pointer i18n-drop-down"
    >
      <span class="cursor-pointer flex items-center i18n-locale">
        <img class="h-4 w-5" :src="i18n_locale_img" :alt="$i18n.locale" />
        <span class="hidden sm:block ml-2">{{
          getCurrentLocaleData.lang
        }}</span>
      </span>
      <vs-dropdown-menu class="w-48 i18n-dropdown vx-navbar-dropdown">
        <vs-dropdown-item @click="updateLocale('en')"
          ><img
            class="h-4 w-5 mr-1"
            src="@/assets/images/flags/en.png"
            alt="en"
          />
          &nbsp;English</vs-dropdown-item
        >
        <vs-dropdown-item @click="updateLocale('it')"
          ><img
            class="h-4 w-5 mr-1"
            src="@/assets/images/flags/it.png"
            alt="it"
          />
          &nbsp;Italian</vs-dropdown-item
        >
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>
<style scoped>
.i18n-drop-down {
  margin-right: 15px;
}
</style>
<script>
import { getCountryName, setLocale } from "@/utils/auth";

export default {
  computed: {
    i18n_locale_img() {
      this.$i18n.locale = this.$i18n.locale;
      const flag = this.$i18n.locale == "mr" ? "in" : this.$i18n.locale;
      try {
        return require(`@/assets/images/flags/${flag}.png`);
      } catch {
        return "";
      }
    },
    getCurrentLocaleData() {
      const locale = this.$i18n.locale;
      if (locale === "en") return { flag: "us", lang: "English" };
      else if (locale === "it") return { flag: "it", lang: "Italian" };
      else return { flag: locale, lang: getCountryName(locale) };
    },
  },
  created() {
     this.$i18n.locale = this.$store.getters.locale !== null ? this.$store.getters.locale : "en";
     if (this.$store.getters.locale == null) {
        this.updateLocale("en");
     }
  },
  methods: {
    updateLocale(locale) {
      this.$i18n.locale = locale;
      let role = this.$store.getters.roles;
      let id =
        role == "super_admin" || role == "user"
          ? this.$store.getters.currentUser.id
          : this.$store.getters.currentUser.staff_id;
      var data = {
        user_id: id,
        user_role: role,
        language: locale,
      };
      this.$store
        .dispatch("SetLang", data)
        .then((res) => {
          setLocale(locale);
        })
        .catch((error) => {
          this.$log.error(
            "File : I18n.vue | Function : setLang() | Error :",
            error
          );
          return false;
        });
    },
  },
};
</script>
